import { havingDeletePermission } from "@/utility/common";
import { GetCommonDeleteImgButton } from "@/components/Images/CommonImages";

export const useCustomCellRenderers = (
  isVisible: any,
  setShowModal: any,
  setActiveClaim: any,
  setDebtorId: any,
  Debtor: string[],
  setDebtorName: any,
) => {
  const caseRenderers = {
    actionCellRenderers: function (param: any) {
      return (
        <>
            {  havingDeletePermission(Debtor) && 
            <GetCommonDeleteImgButton
            onClick={() => {
              setShowModal(true);
              setActiveClaim(param.data.totalClaims);
              setDebtorId(param.data.debtorId);
              setDebtorName(param.data.name);
            }}
            ></GetCommonDeleteImgButton>
            // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
            // <MotifButton
            //   size="small"
            //   variant={DELETE_IMG_VARIANT}
            //   onClick={() => {
            //     setShowModal(true);
            //     setActiveClaim(param.data.totalClaims);
            //     setDebtorId(param.data.debtorId);
            //     setDebtorName(param.data.name);
            //   }}
            //   // disabled={param.data.isActive == true ? false : true}
            // >
            //  {getCommonDeleteImg()}
            // </MotifButton>
            // </CommonTooltipWrapper>
            }
          
         
        </>
      );
    },
  };
  return caseRenderers;
};
